import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";
import { dashboardsUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import { Dashboard, DashboardStatus } from "@src/types/dashboards";

export interface CreateDashboardPayload {
  name: string;
  description?: string | null;
  status?: DashboardStatus;
  is_default?: boolean;
}

export const postCreateDashboardV2 = async (
  namespace: string,
  payload: CreateDashboardPayload,
): Promise<{ data: Dashboard }> => {
  const url = dashboardsUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();

  try {
    const response = await axios.post<Dashboard>(
      `${url}/api/v2/ns/${namespace}/dashboards`,
      payload,
      { headers },
    );
    return response;
  } catch (err) {
    if (isAxiosError(err)) {
      console.error("Axios error:", err);
      throw new Error(
        err.response?.data?.detail ||
          err.response?.data?.message ||
          "Failed to create dashboard. Please try again later.",
      );
    }
    throw new Error("An unexpected error occurred while creating dashboard.");
  }
};
